import { Spinner } from "./Spinner";

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = "Loading..." }: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background/80">
      <Spinner size={48} className="text-primary" />
      <p className="mt-4 text-lg text-muted-foreground">{message}</p>
    </div>
  );
}
